import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "../Theme";
import { Link } from "react-router-dom";


function CategoryList() {
  const [url, setUrl] = useState("");
  const [watchlist, setWatchlist] = useState({});
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("Best Match");
  const navigate = useNavigate();
  const { type } = useParams();
  const { darkMode } = useTheme();
  const [verifiedOnly, setVerifiedOnly] = useState(false);

  const themeClasses = darkMode
    ? "bg-slate-700 text-white"
    : "bg-white text-black";

  const data = [
    {
      type: "Automotive",
      desc: "Manufacturing of motors and vehicles...",
      image:
        "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=600",
    },
    {
      type: "Electronics",
      desc: "Manufacturing of consumer electronics...",
      image:
        "https://images.unsplash.com/photo-1510557880182-3d4d3cba35a5?w=600",
    },
    {
      type: "Metallurgy",
      desc: "Production, refining, and processing of metals...",
      image:
        "https://images.unsplash.com/photo-1581091215367-59ab6b6dba7c?w=600",
    },
    {
      type: "Chemicals",
      desc: "Production of chemicals and fertilizers...",
      image:
        "https://images.unsplash.com/photo-1581091870627-3a7c1b4d9f89?w=600",
    },
    {
      type: "Medical Devices",
      desc: "Manufacturing of medical equipment...",
      image:
        "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=600",
    },
    {
      type: "Food & Beverages",
      desc: "Production and processing of food products...",
      image:
        "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600",
    },
  ];

  const products = [
    { name: "Brake Pads", price: "$49.99" },
    { name: "Engine Oil", price: "$29.99" },
    { name: "Alloy Wheels", price: "$199.99" },
    { name: "Car Battery", price: "$89.99" },
    { name: "Headlights", price: "$59.99" },
    { name: "Seat Covers", price: "$39.99" },
    { name: "Dash Camera", price: "$79.99" },
    { name: "Car Stereo", price: "$149.99" },
  ];

  const sortedProducts = [...products].sort((a, b) => {
    if (sortBy === "Price: Low to High") {
      return parseFloat(a.price.replace("$", "")) - parseFloat(b.price.replace("$", ""));
    }
  
  
  
    if (sortBy === "Price: High to Low") {
      return parseFloat(b.price.replace("$", "")) - parseFloat(a.price.replace("$", ""));
    }
  
    if (sortBy === "Newest") {
      return b.name.localeCompare(a.name);
    }
  
    return 0; // Best Match (default)
  });

  const visibleProducts = verifiedOnly
  ? sortedProducts.filter((_, i) => i % 2 === 0)
  : sortedProducts;

  return (
    <div className="bg-white min-h-screen">
    <div className="max-w-[1400px] mx-auto px-8 py-10">
    {/* EBAY STYLE BREADCRUMB */}
{type && (
  <div className="text-sm text-gray-500 mb-4">
    <span
      onClick={() => navigate("/category")}
      className="cursor-pointer hover:underline"
    >
      Categories
    </span>
    {type && (
  <>
    {" > "}
    <span className="text-gray-700 font-medium">
      {type}
    </span>
  </>
)}
  </div>
)}
    <h1 className="text-2xl font-bold mb-6">
        {type ? `${type} Products` : "Manufacturing Categories"}
      </h1>

      {/* CATEGORY GRID (No type selected) */}
      {!type && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {data.map((company, index) => (
            <div
              key={index}
              onClick={() => navigate(`/category/${company.type}`)}
              className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition duration-200 cursor-pointer overflow-hidden"
            >
              <img
                src={company.image}
                alt={company.type}
                className="w-full h-48 object-cover"
              />

              <div className="p-3">
                <h2 className="text-base font-semibold mb-1">
                  {company.type}
                </h2>

                <p className="text-sm text-gray-500">{company.desc}</p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* PRODUCT PAGE (When type exists) */}
      {type && (
        <div className="flex gap-6">

          {/* LEFT FILTERS */}
          <div className="w-1/5 hidden md:block">
          <h3 className="text-base font-semibold mb-3 flex items-center justify-between">
            <span>Filters</span>

            {verifiedOnly && (
              <span
                onClick={() => setVerifiedOnly(false)}
                className="text-xs text-blue-600 cursor-pointer hover:underline"
              >
                Clear
              </span>
            )}
          </h3>

          <div className="space-y-2 text-sm text-gray-700">
            <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={verifiedOnly}
              onChange={() => setVerifiedOnly(prev => !prev)}
            />
              Verified Suppliers
            </label>

            <label className="flex items-center gap-2">
              <input type="checkbox" />
              ISO Certified
            </label>

            <label className="flex items-center gap-2">
              <input type="checkbox" />
              USA Based
            </label>
          </div>
        </div>

        {/* RIGHT PRODUCTS SECTION */}
      <div className="flex-1">

      {/* EBAY STYLE SEARCH BAR */}
      <div className="flex gap-3 mb-6">
        <input
          type="text"
          placeholder="Search for anything"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-1 border border-gray-300 rounded-full px-5 py-2 text-sm outline-none"
        />
        <button className="bg-blue-600 text-white px-6 rounded-full text-sm">
          Search
        </button>
      </div>

            {/* Results + Sort */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between border-b pb-4 mb-6 gap-3">

  <div>
    <p className="text-lg font-semibold">
      {type}
    </p>
    <p className="text-sm text-gray-500">
      {products.length} Results
    </p>
  </div>

  <div className="flex items-center gap-2">
    <span className="text-sm text-gray-500">Sort by:</span>
    <select
  value={sortBy}
  onChange={(e) => setSortBy(e.target.value)}
  className="border border-gray-300 rounded px-3 py-1 text-sm bg-white"
>
      <option>Best Match</option>
      <option>Newest</option>
      <option>Price: Low to High</option>
      <option>Price: High to Low</option>
    </select>
  </div>

</div>

            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
    {visibleProducts.map((product, index) => (
    <div
    key={index}
    className="group bg-white border border-gray-200 rounded-xl p-3 hover:shadow-lg transition cursor-pointer"
    >

<div className="relative aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden mb-3">
  <img
    src="https://images.unsplash.com/photo-1581091215367-59ab6b6dba7c?w=600"
    alt={product.name}
    className="w-full h-full object-cover group-hover:scale-105 transition duration-200"
  />
  {/* WATCHLIST HEART */}

  <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setWatchlist(prev => ({
        ...prev,
        [index]: !prev[index]
      }));
    }}
    className="bg-white p-2 rounded-full shadow hover:scale-110 transition"
  >
    <span className={watchlist[index] ? "text-red-500" : "text-gray-400"}>
      ♥
    </span>
  </button>
</div>


  {/* QUICK VIEW OVERLAY */}
  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">

    <Link
      to="/productDetails"
    >
      <button className="bg-white text-sm px-4 py-2 rounded-md font-medium">
        View Details
      </button>
    </Link>
    
  </div>
</div>

      <h2 className="text-sm font-medium leading-tight">
  {product.name}
</h2>

<p className="text-xs text-gray-500 mt-1 flex items-center gap-2">
  <span>Brand New</span>
  <span>·</span>
  <span className="text-yellow-500">★★★★★</span>
  <span>(4.8)</span>
</p>

<div className="flex items-center gap-2 mt-1">

  <p className="text-base font-bold text-black">
    {product.price}
  </p>

  <p className="text-xs text-gray-400 line-through">
    $79.99
  </p>

  <span className="text-xs text-green-600 font-medium">
    38% OFF
  </span>

</div>

      <p className="text-xs text-gray-500">
        Free Shipping
      </p>

    </div>
  ))}
</div>

          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default CategoryList;